import { render, staticRenderFns } from "./SubProcNodeConfig.vue?vue&type=template&id=1afdf272&scoped=true"
import script from "./SubProcNodeConfig.vue?vue&type=script&lang=js"
export * from "./SubProcNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./SubProcNodeConfig.vue?vue&type=style&index=0&id=1afdf272&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afdf272",
  null
  
)

export default component.exports